import React from "react";
import Footer from "../../components/footer/Footer";
import "./Home.css";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Carousel from "../../components/Carousel/Carousel";
import Form from "react-bootstrap/Form";

function Home() {
    const navigate = useNavigate();
    return (
        <>
            <div>
                <div className="Home_Hero">
                    <div className="heroTextConatiner">
                        <h1 className="HomeHeroh1">
                            Elevate Your Writing with Responsible AI
                        </h1>
                        <h3 className="HomeHeroSubheading">
                            Welcome to Humanizer, where responsible AI meets
                            exceptional writing.
                        </h3>
                        <p className="ExtraContent">
                            Empower your communication and safeguard your
                            reputation with our AI writing partner. Whether
                            you're crafting a delicate email, articulating your
                            thoughts, or keeping your projects on track, our AI
                            writing assistant is here to support you every step
                            of the way.
                        </p>
                        <div className="LoginButtonHome">
                            <Button
                                variant="contained"
                                onClick={() => {
                                    navigate("/auth");
                                }}
                                className="ButtonHome"
                            >
                                Login
                            </Button>
                        </div>
                    </div>
                    {/* <div className="Home_Hero_ImageConatiner">
                        <img
                            src="https://miro.medium.com/v2/resize:fit:828/format:webp/1*XZKw2V8qV00MENNGeR2VyA.jpeg"
                            alt="random.jpg"
                            className="Hero_img"
                        />
                    </div> */}
                </div>
                <section id="home-stats">
                    <div className="stats-title">
                        Loved by over 1 million editors
                    </div>
                    <div className="main-stats">
                        <div className="stats-group">
                            <div className="stats-amount">₹20 Cr+</div>
                            <div className="stats-heading">
                                words summarized
                            </div>
                        </div>
                        <div className="stats-group">
                            <div className="stats-amount">₹50 Cr+</div>
                            <div className="stats-heading">
                                sentences analyzed
                            </div>
                        </div>
                        <div className="stats-group">
                            <div className="stats-amount">₹30 Cr+</div>
                            <div className="stats-heading">
                                prompts optimized
                            </div>
                        </div>
                    </div>
                </section>
                <section id="carousel">
                    <Marquee
                        speed={25}
                        pauseOnHover={true}
                        gradient
                        gradientWidth={50}
                    >
                        <Carousel />
                    </Marquee>
                </section>
                <section id="queries">
                    <div className="query-title">
                        Got any queries? Feel free to reach out!
                    </div>
                    <div className="query-box">
                        <Form>
                            <Form.Group
                                className="mb-3"
                                controlId="formBasicEmail"
                            >
                                <Form.Label className="form-field-title">
                                    Email address *
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                />
                                <Form.Text className="text-muted">
                                    We'll never share your email with anyone
                                    else.
                                </Form.Text>
                            </Form.Group>
                            <Form.Group
                                className="mb-4"
                                controlId="querySubject"
                            >
                                <Form.Label className="form-field-title">
                                    Subject *
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Subject"
                                />
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                controlId="queryDescription"
                            >
                                <Form.Label className="form-field-title">
                                    Description *
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Description"
                                />
                            </Form.Group>
                            <Button
                                variant="contained"
                                type="submit"
                                className="ButtonHome"
                                style={{ width: "20%" }}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                Submit
                            </Button>
                        </Form>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default Home;
